<lbca-input-text [maskInput]="fieldProps.mask"
	[label]="labelValue"
	[disabled]="true"
	[referenced]="true"
	[value]="entityValue"
 />
